import React, { useContext } from 'react';
import { isValidElementType } from 'react-is';
import '../../utils/assertions.es.js';
import { maestroComponent } from '../../utils/componentHelpers.es.js';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import 'polished';
import '@styled-system/css';
import 'styled-components';
import '../../utils/useEnhancedEffect.es.js';
import { forwardRef } from '../../system/forwardRef.es.js';
import { List as List$1, ItemIcon as ItemIcon$1, Item as Item$1, Addon, ItemSecondaryAction as ItemSecondaryAction$1, Divider, Subheader as Subheader$1 } from './styled.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const ListContext = React.createContext({ variant: "default", size: "md" });
const ListComponent = forwardRef((_a, ref) => {
  var _b = _a, { children, variant = "default", size = "md" } = _b, props = __objRest(_b, ["children", "variant", "size"]);
  return /* @__PURE__ */ React.createElement(ListContext.Provider, {
    value: { variant, size }
  }, /* @__PURE__ */ React.createElement(List$1, __spreadValues({
    as: "nav",
    role: "menu",
    ref
  }, props), children));
});
ListComponent.displayName = "ListComponent";
const ItemIcon = maestroComponent("List.ItemIcon", ItemIcon$1);
const Item = forwardRef((props, ref) => {
  const context = useContext(ListContext);
  const _a = props, { children, onClick, disabled, isDisabled, icon: IconComponent, addonLeft, addonRight } = _a, rest = __objRest(_a, ["children", "onClick", "disabled", "isDisabled", "icon", "addonLeft", "addonRight"]);
  const handleClick = (event) => {
    if (disabled || isDisabled) {
      return;
    }
    onClick == null ? void 0 : onClick(event);
  };
  return /* @__PURE__ */ React.createElement(Item$1, __spreadValues(__spreadValues({
    ref,
    role: "menuitem",
    onClick: handleClick,
    disabled: disabled || isDisabled
  }, rest), context), isValidElementType(IconComponent) && /* @__PURE__ */ React.createElement(ItemIcon, {
    size: context.size
  }, /* @__PURE__ */ React.createElement(IconComponent, null)), addonLeft && React.Children.map(addonLeft, (addon) => /* @__PURE__ */ React.createElement(Addon, {
    marginRight: "sm"
  }, addon)), children, addonRight && React.Children.map(addonRight, (addon) => /* @__PURE__ */ React.createElement(Addon, {
    marginLeft: "auto"
  }, addon)));
});
Item.displayName = "List.Item";
const Subheader = (_c) => {
  var _d = _c, { size = "sm", contrast = "low" } = _d, props = __objRest(_d, ["size", "contrast"]);
  return /* @__PURE__ */ React.createElement(Subheader$1, __spreadValues({
    size,
    contrast
  }, props));
};
const ItemSecondaryAction = maestroComponent("List.ItemSecondaryAction", ItemSecondaryAction$1);
const ListComposition = {
  Item,
  ItemIcon,
  ItemSecondaryAction,
  Subheader,
  Divider: Divider
};
const List = maestroComponent("List", ListComponent, ListComposition);

export { List, ListContext };
//# sourceMappingURL=List.es.js.map
